/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import isEmpty from 'is-empty';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

import getCustomerCards from '../../actions/setUpCardDetails.actions/getCustomerCards';
import TransactionCards from '../commons/TransactionCards';
import mastercardIcon from '../../template/utils/icons/mastercard.png';
import SelectAccountId from './SelectAccountId';
import { fundingSourceCard } from '../../middlewares/targetSavings/enterSavingDetails';
import buyMoneyMarketMutualFund,
{ deleteBuyMoneyMarketFundError } from '../../actions/mutualFunds.actions/moneyMarketMutualFund';
import fixtipInvestment, { deletefixtipInvestmentError } from
  '../../actions/investment.actions/fixtip.action';
import { ErrorAlertNotification } from '../commons/index';
import mtLipInvestment, { deleteMtLipInvestmentError } from '../../actions/investment.actions/mtLipActions/mtlip.action';

/**
 * @class SelectCardId
 */
class SelectCardId extends Component {
    state = {
      cardId: '',
      error: {},
      modalTarget: '',
      dismissModal: '',
    }

    componentWillMount = () => {
      const { GetCustomerCards } = this.props;
      GetCustomerCards();
    }

    /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  onHandleRadioButton = (event) => {
    this.setState({
      cardId: event.currentTarget.value,
      errors: {}
    });
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  handleDelete = () => {
    const mutualActionType = Cookies.get('mutual_Modal');
    if (mutualActionType === 'mutualModal') {
      const { DeleteBuyMoneyMarketFundError } = this.props;
      DeleteBuyMoneyMarketFundError();
    }
    if (mutualActionType === 'fixtipModal') {
      const { DeletefixtipInvestmentError } = this.props;
      DeletefixtipInvestmentError();
    }
    if (mutualActionType === 'mtLipModal') {
      const { DeleteMtLipInvestmentError } = this.props;
      DeleteMtLipInvestmentError();
    }
  }

  /**
   *
   *
   * @returns {*} - state
   */
  onCheckCardId = () => {
    const {
      existingCardPayload,
      MutualModal,
      history,
      BuyMoneyMarketMutualFund,
      FixtipInvestment,
      MtLipInvestment,
    } = this.props;
    const { cardId } = this.state;
    if (this.isValidCardIdCheck()) {
      if (MutualModal === 'mutualFund') {
        const mainMutualFundPayload = {
          ...existingCardPayload,
          cardId
        };
        BuyMoneyMarketMutualFund(mainMutualFundPayload, history);
      }

      if (MutualModal === 'fixtipModal') {
        const mainFixtipPayload = {
          ...existingCardPayload,
          cardId
        };
        FixtipInvestment(mainFixtipPayload);
      }

      if (MutualModal === 'mtLipModal') {
        const mainFixtipPayload = {
          ...existingCardPayload,
          cardId
        };
        MtLipInvestment(mainFixtipPayload);
      }

      if (MutualModal !== 'mutualFund' || MutualModal !== 'fixtipModal') {
        this.setState({
          errors: {},
          modalTarget: '#select_account',
          dismissModal: 'modal'
        });
      }
    }
  }

  /**
   *
   * @returns {*} - state
   */
  isValidCardIdCheck = () => {
    const { errors, isValid } = fundingSourceCard(
      this.state
    );
    if (!isValid) {
      this.setState({
        errors,
      });
    }
    return isValid;
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const mutualActionType = Cookies.get('mutual_Modal');
    const {
      customerCards,
      inviteDetails,
      planType,
      error,
      MutualModal,
      buyMutualFundLoading,
      fixtipInvestmentLoading,
      mtLipError,
      mtLipIsLoading,
      fixTipError
    } = this.props;
    const {
      cardId,
      modalTarget,
      dismissModal,
      errors,
    } = this.state;
    const addCardDetails = {
      ...inviteDetails,
      cardId
    };
   
    return (
      <>
        <div className="modal fade" id="select_card" style={{ overflowY: 'scroll' }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal">
                  {' '}
                  <span> Close </span>
                  {' '}
&times;
                </button>
              </div>
              <div className="modal-body">
                <div className="savings_form_inst">
                  <h5 id="newSavingDetails">
                Select Debit Card
                  </h5>
                  <br />
                  <div className="text-center">
                    <p
                      style={{
                        fontSize: '14px'
                      }}
                    >
                Please note it is mandatory you select a debit card
                    </p>
                  </div>
                </div>
                {!isEmpty(error) || !isEmpty(mtLipError) || !isEmpty(fixTipError) ? (
                  <ErrorAlertNotification
                    errors={error || mtLipError || fixTipError}
                    onClick={this.handleDelete}
                  />
                ) : ''}
                {
                    isEmpty(customerCards.customerCards) ? (
                      <div className="text-center">
                        <p
                          style={{
                            color: 'green'
                          }}
                        >
                        You are yet to add a new card.
                          <a href="/add-card">
                          Click Here
                          </a>
                          {' '}
to set up bank details to add card.
                        </p>
                      </div>
                    ) : (
                      <>
                        {errors && <p className="text-danger">{errors.cardId}</p>}
                        {
                        customerCards.customerCards.map(card => (
                          <TransactionCards
                            key={card.id}
                            card={card}
                            src={mastercardIcon}
                            name="cardId"
                            value={card.id}
                            defaultChecked={cardId === card.id}
                            onChange={this.onHandleRadioButton}
                          />
                        ))
                      }
                      </>
                    )
                }
                <div className="btn_full_width green_btn">
                  {
                        isEmpty(customerCards.customerCards) ? ''
                          : buyMutualFundLoading || fixtipInvestmentLoading || mtLipIsLoading ? (
                            <button
                              data-toggle="modal" data-target={modalTarget || ''}
                              data-dismiss={
                                MutualModal === 'mutualFund'
                                || MutualModal === 'fixtipModal' || mutualActionType === 'mutualModal' || mutualActionType === 'fixtipModal' ? '' : dismissModal || ''
                              }
                              onClick={this.onCheckCardId}
                              type="button"
                            >
                              <i className="fa fa-spinner fa-spin" />
                              {' '}
&nbsp;
                              {
                                MutualModal === 'mutualFund'
                                || MutualModal === 'fixtipModal' || mutualActionType === 'mutualModal' || mutualActionType === 'fixtipModal' || MutualModal === 'mtLipModal' ? 'Buy' : 'Next'
                              }
                            </button>
                          )
                            : (
                              <button
                                data-toggle="modal" data-target={modalTarget || ''}
                                data-dismiss={
                                MutualModal === 'mutualFund' || MutualModal === 'fixtipModal' || mutualActionType === 'mutualModal' || mutualActionType === 'fixtipModal' ? '' : dismissModal || ''
                              }
                                onClick={this.onCheckCardId}
                                type="button"
                              >
                                {
                                MutualModal === 'mutualFund'
                                || MutualModal === 'fixtipModal' || MutualModal === 'mtLipModal' || mutualActionType === 'mutualModal' || mutualActionType === 'fixtipModal' ? 'Buy' : 'Next'
                              }
                              </button>
                            )
                      }
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          MutualModal === 'mutualFund' || MutualModal === 'fixtipModal' || MutualModal === 'mtLipModal' ? '' : (
            <SelectAccountId
              addCardDetails={addCardDetails}
              planType={planType}
            />
          )
        }
      </>
    );
  }
}

SelectCardId.propTypes = {
  customerCards: PropTypes.any,
  inviteDetails: PropTypes.shape({}),
  GetCustomerCards: PropTypes.func,
  planType: PropTypes.string,
  DeleteBuyMoneyMarketFundError: PropTypes.func,
  error: PropTypes.any,
  BuyMoneyMarketMutualFund: PropTypes.func,
  MutualModal: PropTypes.string,
  existingCardPayload: PropTypes.shape({}),
  history: PropTypes.shape({}),
  buyMutualFundLoading: PropTypes.bool,
  FixtipInvestment: PropTypes.func,
  DeletefixtipInvestmentError: PropTypes.func,
  fixtipInvestmentLoading: PropTypes.bool,
  DeleteMtLipInvestmentError: PropTypes.func,
  mtLipError: PropTypes.any,
  MtLipInvestment: PropTypes.func,
  mtLipIsLoading: PropTypes.bool,
};

const mapStateToProps = state => ({
  customerCards: state.getCards.customerCards,
  error: state.mutualFundMoneyMarket.error,
  buyMutualFundLoading: state.mutualFundMoneyMarket.loading,
  fixtipInvestmentLoading: state.fixtipInvestment.loading,
  mtLipError: state.mtLipInvestment.error,
  fixTipError: state.fixtipInvestment.error,
  mtLipIsLoading: state.mtLipInvestment.loading,
});

export default withRouter(connect(mapStateToProps, {
  GetCustomerCards: getCustomerCards,
  BuyMoneyMarketMutualFund: buyMoneyMarketMutualFund,
  DeleteBuyMoneyMarketFundError: deleteBuyMoneyMarketFundError,
  FixtipInvestment: fixtipInvestment,
  DeletefixtipInvestmentError: deletefixtipInvestmentError,
  MtLipInvestment: mtLipInvestment,
  DeleteMtLipInvestmentError: deleteMtLipInvestmentError
})(SelectCardId));
